import { Link } from 'react-router-dom';
import { faqItems } from '@/mocks/faq';
import FaqAccordion from '@/components/feature/FaqAccordion';

export default function HomeFaq() {
  const preview = faqItems.slice(0, 4);
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-accent-700">
              <i className="ri-question-answer-line" aria-hidden="true"></i>
              常见问题
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              先回答你最关心的几个问题
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-[15px]">
              关于可信度、匿名保护、勘误与立场，我们把话说在前面。还有更多疑问，可以到完整版查看。
            </p>
            <Link
              to="/faq"
              className="mt-5 inline-flex items-center gap-1.5 rounded-md border border-background-300 px-4 py-2 text-xs font-semibold whitespace-nowrap text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              查看全部 FAQ
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
          <div className="lg:col-span-8">
            <FaqAccordion items={preview} defaultOpen={0} />
          </div>
        </div>
      </div>
    </section>
  );
}